/**
 * Sports betting tips & predictions — `/betting-gaming/sports-betting-tips`
 */
import {
  SPORTS_BETTING_TIPS_SLUG,
  sportsBettingTipsDefaultData,
} from "./sportsBettingTipsData";
import {
  SportsBettingTipsArticlesTab,
  SportsBettingTipsMediaTab,
  SportsBettingTipsOverviewTab,
} from "./SportsBettingTipsDesign";

export const sportsBettingTipsModule = {
  slug: SPORTS_BETTING_TIPS_SLUG,
  getDefaultData: () => sportsBettingTipsDefaultData,
  Views: {
    overview: SportsBettingTipsOverviewTab,
    articles: SportsBettingTipsArticlesTab,
    media: SportsBettingTipsMediaTab,
  },
};
